<template>
    <ul :class="['blog-category', theme]">
        <li class="item" v-for="item in list" :key="item.id">
            <a :href="`/blog?categoryId=${item.id}`" rel="noopener noreferrer">
                <span
                    :class="`name ${categoryId === item.id ? 'active' : ''}`"
                >{{ translateHtmlText(item.name) }}</span
                >
                <span
                    v-if="showCategoryCount && theme != 'template2'"
                    class="num"
                >({{ item.count }})</span
                >
                <span
                    v-if="showCategoryCount && theme == 'template2'"
                    class="num"
                >{{ item.count }}</span
                >
            </a>
        </li>
    </ul>
</template>

<script>
import util from '@/common/util';
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        },
        showCategoryCount: {
            type: Boolean,
            default: false
        },
        categoryId: [String, Number],
        theme: {
            type: String,
            default: ''
        }
    },
    methods: {
        translateHtmlText(txt) {
            if (util.isSSRServer) {
                return txt.replace(/<[^>]+>/g, '').trim();
            } else {
                let div = document.createElement('div');
                div.innerHTML = txt;
                return div.innerText;
            }
        }
    }
};
</script>

<style lang="scss">
@import './common.scss';
@import '../../theme/mixin.scss';
@import '../../theme/media.scss';
.blog-category {
    &.standard {
        .item {
            border-bottom: 1px solid #f4f5f8;
            .name {
                color: #515666;
                &.active {
                    color: #202437;
                }
            }
            .num {
                color: #a0a3af;
            }
        }
    }
    &.template4 {
        .item {
            border-bottom: 1px solid #e5e8f1;
            .name {
                color: #4a4a60;
                &.active {
                    color: #4a4a60;
                }
            }
            .num {
                color: #8b93a8;
            }
        }
    }
    &.template2 {
        .item {
            border-bottom: 1px solid #eaeaea;
            .name {
                color: #333;

                &.active {
                    color: #333;
                }
            }

            .num {
                float: right;
                line-height: 23px;
                border-radius: 2px;
                border: 1px solid #cbcbcb;
                font-size: 14px;
                @include color-theme();
                padding: 0 10px;
                text-align: center;
                margin-top: 12px;
            }
        }
    }
    &.broker {
        .item {
            .name {
                color: #515666;
                &.active {
                    font-family: var(--font-medium);
                    color: #202437;
                    @include media-600 {
                        font: 14px var(--font-medium);
                    }
                }
            }
            .num {
                color: #a0a3af;
            }
        }
    }
}
</style>
